import React from 'react';
import styled from 'styled-components';

interface ICoinIconProps {
  user?: 'landlord' | 'tenant';
}

const StyledSvg = styled.svg<ICoinIconProps>`
  display: block;

  path {
    fill: ${({ theme, user }) => user && theme.colors[user].main};
  }
`;

const Coin = ({ user = 'landlord' }: ICoinIconProps): JSX.Element => (
  <StyledSvg
    user={user}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 24a11.921 11.921 0 01-8.485-3.515A11.921 11.921 0 010 12c0-3.205 1.248-6.219 3.515-8.485A11.921 11.921 0 0112 0c3.205 0 6.219 1.248 8.485 3.515A11.921 11.921 0 0124 12c0 3.205-1.248 6.219-3.515 8.485A11.922 11.922 0 0112 24zM12 .937C5.9.937.937 5.9.937 12 .937 18.1 5.9 23.063 12 23.063c6.1 0 11.063-4.963 11.063-11.063C23.063 5.9 18.1.937 12 .937z"
      fill="#000"
    />
    <path
      d="M12.011 20.81a8.876 8.876 0 01-4.192-1.05.469.469 0 01.444-.826c3.036 1.636 6.862 1.074 9.303-1.368a7.824 7.824 0 002.307-5.568c0-2.104-.82-4.082-2.307-5.57-3.07-3.07-8.067-3.07-11.138 0-2.44 2.442-3.003 6.267-1.367 9.303a.469.469 0 11-.826.445 8.882 8.882 0 01-.966-5.4 8.736 8.736 0 012.497-5.01c3.436-3.437 9.027-3.437 12.463 0a8.755 8.755 0 012.581 6.232 8.757 8.757 0 01-2.58 6.231 8.737 8.737 0 01-6.219 2.58z"
      fill="#000"
    />
    <path
      d="M6.092 18.371a.467.467 0 01-.333-.799l.005-.005a.469.469 0 01.666.66l-.005.005a.467.467 0 01-.333.14zM13.925 15.413a2.835 2.835 0 01-1.466.411c-1.323 0-2.464-.932-2.973-2.266h2.432a.469.469 0 100-.937H9.245a4.492 4.492 0 01-.017-1.108h3.401a.469.469 0 100-.937H9.436c.481-1.407 1.655-2.404 3.023-2.404.514 0 1.008.138 1.466.411a.469.469 0 00.48-.805 3.812 3.812 0 00-1.946-.544c-1.877 0-3.47 1.408-4.004 3.342h-.889a.469.469 0 000 .937h.72a5.428 5.428 0 00.014 1.108h-.734a.469.469 0 000 .937h.93c.57 1.863 2.13 3.204 3.963 3.204.676 0 1.349-.188 1.946-.544a.469.469 0 10-.48-.805z"
      fill="#000"
    />
  </StyledSvg>
);

export default Coin;
